import { Injectable, Inject } from 'ng-metadata/core';
import { HttpService } from '../../../../infra/httpRequest/http.service';
import { getInstitutionCode, getInstitutionId } from '../../../../appConfig/appConfigForward';
import { HighlightService } from '../../../../infra/highlight.service';
import { NgrsService } from '../ngrs.service';
import {mmsIdOfferOutputMap, OfferOutputResults} from "../BestOffer.interface";
import { JwtUtilService } from "../../../../security/jwtUtil.service";
import { getResourceType, getPublicationDate } from '../../../../infra/ngrsUtil';
import {PermalinkService} from "../../../actions/permalinkAction/permalink.service";
import {ConfigurationUtil} from "../../../../nddUtils/configurationUtil.service";
import {DateUtils} from "../../../../nddUtils/dateUtils.service";


const get = require('lodash/get');

@Injectable()
export class PhysicalBestOfferService {
    private primaBaseUrl: any;
    private digitalOfferUrl: any;
    private eBookOfferUrl: any;
    private primaRequestBaseUrl: any;
    private primaPickupLocationBaseUrl: any;
    private primaEmailUrl: any;
    private primaCopyRightsStatementUrl: any;
    private ilsServices: object = {};
    private _mmsid: any;
    private _instId = getInstitutionId();
    private _instCode = getInstitutionCode();
    private resquestInProgress: Object = {};
    private _resultsObject: OfferOutputResults[];
    private isTimeOutFromRapid: boolean;

    constructor(private httpService: HttpService,
        private ngrsService: NgrsService,
        private permalinkService: PermalinkService,
        private jwtUtilService: JwtUtilService,
        @Inject('$translate') private $translate,
        @Inject('restBaseURLs') private restBaseURLs,
        @Inject('$http') private $http: ng.IHttpService,
        @Inject('$q') private $q: ng.IQService,
        private configurationUtil: ConfigurationUtil,
        private dateUtils: DateUtils) {
        this.primaBaseUrl = restBaseURLs.bestOfferURL;
        this.digitalOfferUrl = restBaseURLs.digitalBestOfferURL;
        this.eBookOfferUrl = restBaseURLs.ebookBestOfferURL;
        this.primaRequestBaseUrl = restBaseURLs.ngrsCreateBorrowingRequestURL;
        this.primaPickupLocationBaseUrl = restBaseURLs.primaPickupLocationBaseUrl;
        this.primaEmailUrl = restBaseURLs.primaEmailUrl;
        this.primaCopyRightsStatementUrl = restBaseURLs.primaCopyRightsStatementUrl;

        this.ilsServices = {
            '/bestoffer/physical': {
                'path': this.primaBaseUrl,
                'method': 'GET'
            },
            '/bestoffer/digital': {
                'path': this.digitalOfferUrl,
                'method': 'GET'
            },
            '/bestoffer/eBook': {
                'path': this.eBookOfferUrl,
                'method': 'GET'
            },
            '/bestoffer/borrowingrequest': {
                'path': this.primaRequestBaseUrl,
                'method': 'POST'
            },
            '/bestoffer/pickupLocation': {
                'path': this.primaPickupLocationBaseUrl,
                'method': 'GET'
            },
            '/bestoffer/email': {
                'path': this.primaEmailUrl,
                'method': 'GET'
            },
            '/bestoffer/copyRightsStatement': {
                'path': this.primaCopyRightsStatementUrl,
                'method': 'GET'
            }
        };

    }

    public getbestOffer(mmsid, item: Object, pickupInformation: Object, formData?: object, checkEbook?: boolean, selectedResourceType?: string) {
        if (checkEbook && this.isBookOrEbookResource(item)) {
            return Promise.all([this.getBestPhysicalOffer(mmsid, item, pickupInformation, formData, selectedResourceType),
                this.getBestEbookOffer(mmsid, item, pickupInformation, formData)]);
        } else {
            return this.getBestPhysicalOffer(mmsid, item, pickupInformation, formData, selectedResourceType);
        }
    }

    public getBestEbookOffer(mmsid, item: Object, pickupInformation: Object, formData?: object) {
        return this.getBestOfferInner(mmsid, item, pickupInformation, formData, '/bestoffer/eBook');
    }

    public getBestPhysicalOffer(mmsid, item: Object, pickupInformation: Object, formData?: object, selectedResourceType?: string) {
        return this.getBestOfferInner(mmsid, item, pickupInformation, formData, '/bestoffer/physical', selectedResourceType);
    }

    public getBestOfferInner(mmsid, item: Object, pickupInformation: Object, formData?: object, path?: string, selectedResourceType?: string) {
        let params = this.getParamsForPhysicalBestOffer(item, pickupInformation, formData);
        params['mmsid'] = mmsid;
        if (selectedResourceType) {
            params['selectedResourceType'] = selectedResourceType;
        }
        this.resquestInProgress[path] = true;

        return this.makeIlsRequest(path, params);
    }

    public getDigitalBestOffer(mmsid, item: Object, formData?: object) {
        this.resquestInProgress['/bestoffer/digital'] = true;
        let issn = this.getIssnFromItem(item);
        let params = {
            mmsid: mmsid,
            publicationDate: getPublicationDate(item),
            isbn: this.getIsbnFromItem(item),
            issn: issn,
            title: get(item, 'pnx.display.title'),
            format: get(item, 'pnx.addata.format'),
            resourceType: getResourceType(item, formData),
            edition: get(item, 'pnx.addata.edition'),
            creator: get(item, 'pnx.display.creator'),
            volume: get(item, 'pnx.addata.volume'),
            oclc: get(item, 'pnx.addata.oclcid'),
            issue: get(item, 'pnx.addata.issue'),
            atitle: get(item, 'pnx.addata.atitle'),
            formData: formData
        };
        let resourceType = getResourceType(item, formData);
        if (resourceType == 'bookitem') {
            let partOf = get(item, 'pnx.display.ispartof');
            if (partOf && partOf[0]) {
                partOf = partOf[0].split(",");
                params.title = partOf[0];
                params.chapterTitle = get(item, 'pnx.addata.atitle');
            }
        } else if (resourceType === 'article' && formData && formData.myArticleTitle) {
            params.atitle = formData.myArticleTitle;

        }
        return this.makeIlsRequest('/bestoffer/digital', params);
    }

    private getIssnFromItem(item) {
        var issn;
        issn = get(item, 'pnx.addata.issn');
        if (!issn) {
            issn = get(item, 'pnx.search.issn');
        }
 		if (!issn) {
            issn = get(item, 'pnx.addata.eissn');
        }
        return issn;
    }


    private getIsbnFromItem(item) {
        var isbn;
        isbn = get(item, 'pnx.addata.isbn');
        if (!isbn) {
            isbn = get(item, 'pnx.addata.eisbn');
        }
        return isbn;
    }

    public getbestOfferByGlobalIndex(globalId, item: Object, pickupInformation, formData?: object, eBook?: boolean, selectedResourceType?: string) {
        if (eBook && this.isBookOrEbookResource(item)) {
            return Promise.all([this.getBestPhysicalOfferByGlobalIndex(globalId, item, pickupInformation, formData, selectedResourceType),
                this.getBestEbookOfferByGlobalIndex(globalId, item, pickupInformation, formData)]);
        } else {
            return this.getBestPhysicalOfferByGlobalIndex(globalId, item, pickupInformation, formData, selectedResourceType);
        }
    }

    public getBestPhysicalOfferByGlobalIndex(globalId, item: Object, pickupInformation, formData?: object, selectedResourceType?: string) {
        return this.getBestOfferByGlobalIndexInner(globalId, item, pickupInformation, formData, '/bestoffer/physical', selectedResourceType);
    }

    public getBestEbookOfferByGlobalIndex(globalId, item: Object, pickupInformation, formData?: object) {
        return this.getBestOfferByGlobalIndexInner(globalId, item, pickupInformation, formData, '/bestoffer/eBook');
    }

    getBestOfferByGlobalIndexInner(globalId, item: Object, pickupInformation, formData?: object, path?: string, selectedResourceType?: string) {
        let params = this.getParamsForPhysicalBestOffer(item, pickupInformation, formData);
        this.resquestInProgress[path] = true;
        params['globalTitleIndex'] = globalId;
        if (selectedResourceType) {
            params['selectedResourceType'] = selectedResourceType;
        }

        return this.makeIlsRequest(path, params);
    }

    getParamsForPhysicalBestOffer(item: Object, pickupInformation: Object, formData: Object) {
        let pickupInformationInstCode = pickupInformation ? pickupInformation.institutionCode : undefined;
        let pickupInformationLibraryId = pickupInformation ? pickupInformation.libraryId : undefined;
        let pickupInformationUpdated = pickupInformation ? pickupInformation.pickupInformationUpdated : undefined;
        let chosenPlaceRadio = pickupInformation ? pickupInformation.chosenPlaceRadio : undefined;
        let params = {
            instId: this._instId,
            instCode: this._instCode,
            clientUserId: this.jwtUtilService.getDecodedToken().userGroup,
            publicationDate: getPublicationDate(item),
            isbn: this.getIsbnFromItem(item),
            issn: this.getIssnFromItem(item),
            title: get(item, 'pnx.display.title'),
            format: get(item, 'pnx.addata.format'),
            resourceType: getResourceType(item),
            edition: get(item, 'pnx.addata.edition'),
            creator: get(item, 'pnx.display.creator'),
            volume: get(item, 'pnx.addata.volume'),
            oclc: get(item, 'pnx.addata.oclcid'),
            issue: get(item, 'pnx.addata.issue'),
            atitle: get(item, 'pnx.addata.atitle'),
            pickupInformationInstCode: pickupInformationInstCode,
            pickupInformationLibraryId: pickupInformationLibraryId,
            pickupInformationUpdated: pickupInformationUpdated,
            chosenPlaceRadio: chosenPlaceRadio,
            formData: formData
        };
        return params;
    }

    public getServices() {
        return this.ilsServices;
    }

    makeIlsRequest(serviceName: string, params: Object) {
        if (!params) {
            params = {};
        }
        let ngrsService = this.ilsServices[serviceName];
        this.resquestInProgress[serviceName] = true;

        return this.httpService.call(ngrsService.method, ngrsService.path, params)
            .then(
                (response) => {
                    return this.ilsRequestSuccess(response);
                },
                (error) => {
                    return this.ilsRequestFailure(error, serviceName, params);
                }
            ).finally(() =>
                this.resquestInProgress[serviceName] = false
            );
    }

    get requestInProgress() {
        return this.resquestInProgress || false;
    }

    private ilsRequestSuccess(response) {
        return response;
    }

    private ilsRequestFailure(reason, serviceName, params) {
        console.error(reason, serviceName);
        return reason;
    }

    public createBorrowingRequest(formData: Object, item: Object, bestOffer: Object, alternativeEmailCode: string,
            copyrightApproved: boolean, selectedPickupInformation: Object, runRefine: boolean, offerInitiallyeBook: boolean, selectedResourceType?: string) {
        let pickupInformationInstCode = selectedPickupInformation ? selectedPickupInformation.institutionCode : undefined;
        let pickupInformationLibraryId = selectedPickupInformation ? selectedPickupInformation.libraryId : undefined;
        let chosenPlaceRadio = selectedPickupInformation ? selectedPickupInformation.chosenPlaceRadio : undefined;
        let pickupCZMember = formData.myPickupMember == -1 ? undefined : formData.myPickupMember;

        let params = {
            supplyTime: bestOffer.supplyTime,
            cost: bestOffer.cost,
            currency: bestOffer.currency,
            allowRenewal: bestOffer.allowRenewal,
            supportRush: bestOffer.supportRush,
            memberId: bestOffer.memberId,
            policyId: bestOffer.policyId,
            centralPolicyId: bestOffer.centralPolicyId,
            podId: bestOffer.podId,
            title: get(item, 'pnx.display.title'),
            availableLenderMmsId: bestOffer.availableLenderMmsId,
            lenderMemberId: bestOffer.lenderMemberId,
            lenderMemberName: bestOffer.lenderMemberName,
            lenderInstitutionId: bestOffer.lenderInstitutionId,
            lenderInstitutionCode: bestOffer.lenderInstitutionCode,
            globalIndex: this.getGlobalIndex(item),
            networkRecordId: get(item, 'pnx.control.networklinkedrecordid'),
            rapidoRecordId: get(item, 'pnx.control.rapidosourcerecordid'),
            requesterNote: formData.myNote,
            dueDate: this.dateUtils.convertDateTypeToIlsDateString(formData.myDate),
            volume: this.getVolume(item, formData),
            publicationDate: getPublicationDate(item),
            publisher: get(item, 'pnx.addata.pub'),
            publicationplace: get(item, 'pnx.addata.cop'),
            offerType: bestOffer.offerType,
            isbn: this.getIsbnFromItem(item),
            issn: this.getIssnFromItem(item),
            pnxFormat: getResourceType(item),
            edition: get(item, 'pnx.addata.edition'),
            creator: get(item, 'pnx.display.creator'),
            oclc: this.getOclc(item),
            issue: get(item, 'pnx.addata.issue'),
            atitle: get(item, 'pnx.addata.atitle'),
            jtitle: get(item, 'pnx.addata.jtitle'),
            tpages: get(item, 'pnx.addata.tpages'),
            rotaId: bestOffer.rotaId,
            composer: formData.myComposer,
            opus: formData.myOpus,
            songMovement: formData.mySongMovement,
            part: formData.myPart,
            copyrightapproved: copyrightApproved,
            pickupInformationInstCode: pickupInformationInstCode,
            pickupInformationLibraryId: pickupInformationLibraryId,
            pickupCZMember: pickupCZMember,
            chosenPlaceRadio: chosenPlaceRadio,
            isIlliadLender: bestOffer.illiadLender,
            server: bestOffer.server,
            port: bestOffer.port,
            symbol: bestOffer.symbol,
            source: this.getSource(item),
            unavailableResource: bestOffer.unavailableResource,
            instCode: this._instCode,
            levelOfService: formData.myLevelOfService,
            permalink: this.permalinkService.buildPayload(item, undefined),
            ebookOffer: bestOffer.ebookOffer || offerInitiallyeBook,
            doi:get(item, 'pnx.addata.doi'),
            isRapidILLTimeout : this.isTimeOutFromRapid,
            specificEditionOnly: false,
            runRefine: runRefine,
            selectedResourceType: selectedResourceType,
            primaResourceType: get(item, 'pnx.display.type')
        };
        if (bestOffer.hasOwnProperty('patronCost') && typeof bestOffer.patronCost != "undefined" ){
            params.patronCost = bestOffer.patronCost;
        }
        if (bestOffer.hasOwnProperty('extendDueDateOnCloseBorrowingLibrary') && typeof bestOffer.extendDueDateOnCloseBorrowingLibrary != "undefined" ){
            params.extendDueDateOnCloseBorrowingLibrary = bestOffer.extendDueDateOnCloseBorrowingLibrary;
        }
        // no offer request
        if (typeof bestOffer.memberId === 'undefined' || typeof bestOffer.rotaId !== 'undefined') {
            params.loanPeriod = bestOffer.loanPeriod;
            params.format = bestOffer.policyType;
            this.setPhysicalFields(params, formData);
            this.setDigitalFields(params, formData, alternativeEmailCode);
            params.allowOtherFormat = bestOffer.allowOtherFormat;
        } else if (bestOffer.policyType === "PHYSICAL") {
            params.loanPeriod = bestOffer.loanPeriod;
            params.format = "PHYSICAL";
            this.setPhysicalFields(params, formData);
            params.allowOtherFormat = false;
        } else {
            params.format = "DIGITAL";
            this.setDigitalFields(params, formData, alternativeEmailCode);
            params.allowOtherFormat = false;
            if(bestOffer.ebookOffer){
                params.pickUpLocation = formData.myLocationForEBook;
            }
        }
        if (!isNaN(get(item, 'pnx.control.sourcerecordid'))) {
            params.localMmsId = get(item, 'pnx.control.sourcerecordid');
        }
        if(bestOffer.rapidRRota || bestOffer.ebookOffer){
            params.loanPeriod = bestOffer.loanPeriod;
        }
        if(window.location.pathname.indexOf('openurl') !== -1){
            params.openUrl = window.location.href;
        }
        this.setPartOfFields(params, item, formData);
        return this.makeIlsRequest('/bestoffer/borrowingrequest', params);
    }

    getSource(item: Object) {
        let source = get(item, 'pnx.display.source');
        if(!source) {
            let contextObject = get(item, 'pnx.addata.contextobject');
            if(contextObject) {
                if(contextObject.includes('rft.SOURCE=')) {
                    contextObject = contextObject.substring(contextObject.indexOf('rft.SOURCE=') + 11)
                } else if(contextObject.includes('rec$sourceId=')) {
                    contextObject = contextObject.substring(contextObject.indexOf('rec$sourceId=') + 13)
                } else {
                    return source;
                }
                let ampersandIndex = contextObject.indexOf('&');
                if(ampersandIndex <= 0) {
                    return source;
                }
                source = contextObject.substring(0, ampersandIndex);
            }
        }
        return source;
    }

    getOclc(item: Object){
        let oclc = get(item, 'pnx.addata.oclcid');
        if(!oclc){
            let contextObjectArr = get(item, 'pnx.addata.contextobject');
            if(contextObjectArr && contextObjectArr[0]) {
                let contextObject = contextObjectArr[0];
                if(contextObject.includes('rft.oclcnum=')) {
                    contextObject = contextObject.substr(contextObject.indexOf('rft.oclcnum=') + 12);
                    let ampersandIndex = contextObject.indexOf('&');
                    if(ampersandIndex <= 0) {
                        return oclc;
                    }
                    oclc = [contextObject.substring(0, ampersandIndex)];
                }
            }
        }
        return oclc;
    }

    public setPartOfFields(params, item, formData) {
        let resourceType = getResourceType(item);
        if (resourceType == 'bookitem') {
            let partOf = get(item, 'pnx.display.ispartof');
            if (partOf && partOf[0]) {
                partOf = partOf[0].split(",");
                params.title = partOf[0];
                params.chapterTitle = get(item, 'pnx.addata.atitle');
                params.fromPage = get(item, 'pnx.addata.spage');
                params.toPage = get(item, 'pnx.addata.epage');
                params.volume = get(item, 'pnx.addata.volume');
            }
        } else if (resourceType == 'proceeding') {
            let partOf = get(item, 'pnx.display.ispartof');
            if (partOf && partOf[0]) {
                partOf = partOf[0].split(",");
                params.title = partOf[0];
                params.chapterTitle = get(item, 'pnx.addata.atitle');
                if(params.fromPage === undefined || params.toPage === undefined){
                    params.fromPage = get(item, 'pnx.addata.spage');
                    params.toPage = get(item, 'pnx.addata.epage');
                    params.volume = get(item, 'pnx.addata.volume');
                }
            }
        } else if (resourceType == 'article') {
            params.title = get(item, 'pnx.addata.atitle');
            params.fromPage = get(item, 'pnx.addata.spage');
            params.toPage = get(item, 'pnx.addata.epage');
            if (get(item, 'pnx.addata.spage')) {
                params.tpages = undefined;
            } else {
                params.tpages = get(item, 'pnx.addata.pages');
            }
        } else if (resourceType == 'journal' || resourceType == 'ejournal') {
            params.articleTitle = formData.myArticleTitle;
            params.articleAuthor = formData.myArticleAuthor;
            params.publicationDate = formData.myPublicationDate;
            if(formData.myIssue){
                params.issue = [formData.myIssue];
            }
            params.jtitle = get(item, 'pnx.display.title');
        }
        else if ( resourceType == "reference_entry" || resourceType == "chapter"){
            if(params.fromPage === undefined || params.toPage === undefined){
                params.fromPage = get(item, 'pnx.addata.spage');
                params.toPage = get(item, 'pnx.addata.epage');
                params.volume = get(item, 'pnx.addata.volume');
            }
            params.title = get(item, 'pnx.addata.atitle') + " - " + get(item, 'pnx.addata.btitle');
        }

        if(params.articleTitle==null && !(params.issn==null) && params.issn.length > 0 && (params.isbn==null || params.isbn.length==0) && params.format=="DIGITAL"){
            params.articleTitle = params.atitle;
        }
    }

    private setDigitalFields(params: Object, formData: Object, alternativeEmailCode: string) {
        if (formData.myEmail === alternativeEmailCode) {
            params.email = formData.myAlternativeEmail;
        } else {
            params.email = formData.myEmail;
        }
        params.chapterTitle = formData.myChapterTitle;
        params.chapterAuthor = formData.myChapterAuthor;
        params.chapterNumber = formData.myChapterNumber;
        params.fromPage = formData.myFromPage;
        params.toPage = formData.myToPage;
        params.additionalInformation = formData.myAdditionalInformation;
    }

    private setPhysicalFields(params: Object, formData: Object) {
        params.pickUpLocation = formData.myLocation;
        params.pickupInstitutionFN = formData.myPickupInstitution;
        params.pickupLibraryFN = formData.myPickupLibrary;
        if(formData.mySpecificEditionOnly){
            params.specificEditionOnly = formData.mySpecificEditionOnly;
            params.publicationDate = formData.mySpecificEditionPublicationDate;
            params.edition = formData.myEdition;
        }
    }

    private getVolume(item: Object, formData: Object) {
        if (formData.myVolume) {
            return formData.myVolume;
        }
        return get(item, 'pnx.addata.volume');
    }
    
    private getGlobalIndex(item: Object) {
        let globalIndexArr = get(item, 'pnx.control.gtiid');
        if(!globalIndexArr) {
        	globalIndexArr = get(item, 'pnx.control.recordid');
        } 
        return globalIndexArr;
    }
    

    public getPickupLocation(isFNOffer: boolean) {
        let params = {
            instCode: this._instCode,
            instId: this._instId,
            isFNOffer: isFNOffer 
        };
        return this.makeIlsRequest('/bestoffer/pickupLocation', params);
    }

    public getEmailList() {
        let params = {
            instCode: this._instCode,
            instId: this._instId
        };
        return this.makeIlsRequest('/bestoffer/email', params);
    }

    public getCopyRightsStatement() {
        let params = {
            instCode: this._instCode,
            instId: this._instId
        };
        return this.makeIlsRequest('/bestoffer/copyRightsStatement', params);
    }

    public setResultsObject(response: mmsIdOfferOutputMap[], hash: string) {
        if (this._resultsObject) {
            this._resultsObject[hash] = response[hash];
        } else {
            this._resultsObject = [];
            this._resultsObject[hash] = response[hash];
        }
    }

    public getResultsObject(): mmsIdOfferOutputMap[] {
        return this._resultsObject;
    }

    public resetResultsObject() {
        this._resultsObject = [];
    }

    public getIsTimeOutFromRapid(){
        return this.isTimeOutFromRapid;
    }
    public setIsTimeOutFromRapid(value:boolean){
        this.isTimeOutFromRapid = value;
    }

    public isBookOrEbookResource(item) {
        let resourceType = getResourceType(item);
        if(resourceType == 'book' || resourceType == 'ebook'){
            return true;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/physicalBestOffer/physicalBestOffer.service.ts